<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-card>
          <v-card-title>
            月票繳費
          </v-card-title>

          <v-card-subtitle>
            繳費期間內查詢應繳月票費用
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              to="charging"
            >
              前往
              <v-icon
                dark
                right
              >
                mdi-chevron-right-circle
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-card>
          <v-card-title>
            交易查詢
          </v-card-title>

          <v-card-subtitle>
            提供公司戶交易發票下載報帳
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              to="tradeinfo"
            >
              前往
              <v-icon
                dark
                right
              >
                mdi-chevron-right-circle
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-card>
          <v-card-title>
            註冊手機載具
          </v-card-title>

          <v-card-subtitle>
            設定後不用再索取紙本發票，雲端自動輕鬆兌獎
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              to="changeprofile"
            >
              前往
              <v-icon
                dark
                right
              >
                mdi-chevron-right-circle
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- <v-col class="text-center">
        <h1 class="red--text">系統資料建置中，啟用時間依場地公告</h1>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({})
};
</script>
